import { render, staticRenderFns } from "./supplier-add.vue?vue&type=template&id=55dd20d3"
import script from "./supplier-add.vue?vue&type=script&lang=js"
export * from "./supplier-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dd20d3')) {
      api.createRecord('55dd20d3', component.options)
    } else {
      api.reload('55dd20d3', component.options)
    }
    module.hot.accept("./supplier-add.vue?vue&type=template&id=55dd20d3", function () {
      api.rerender('55dd20d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier-add.vue"
export default component.exports